var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"add-team overflow-y-scroll w-full z-10",on:{"click":_vm.clickOnBackground}},[_c('div',{staticClass:"popup-container w-full"},[_c('div',{staticClass:"popup w-full",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();}}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }